import React from "react";
import ReactSwitch from "component/atoms/switch/SVGIconSwitch";
import ReactGA from "react-ga";
import SVGIcons from "assets/icon";
import Slider from "component/atoms/slider";
import brushModule from "component/molecules/viewport/tools/annotation/brushTool/brushModule";
import CustomEvent from "core/customEvent";
import { getEnabledElements } from "component/toolManager/enabledElements.js";
import { getToolState, addToolState } from "component/toolManager/toolState.js";
import BaseBrushTool from "component/molecules/viewport/tools/annotation/base/BaseBrushTool";

import PropTypes from "prop-types";

import "component/atoms/slider/assets/index.css";
import { inject } from "mobx-react";
import { observer } from "mobx-react";

const Handle = Slider.Handle;
const handle = (props) => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <Handle offset={"-3"} value={value} vertical={true} {...restProps}>
      <SVGIcons.SVGThumbIcon></SVGIcons.SVGThumbIcon>
    </Handle>
  );
};

/**
 * @class OpacityPanel
 */
@inject("sarcopeniaMeasureStore")
@observer
class OpacityPanel extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
  };
  static defaultProps = {
    disabled: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      opacity: parseInt(props.opacity),
      visibility: true,
    };
  }

  handleOpacitySliderChange = (value) => {
    // Send user event to Google Analytics
    ReactGA.event({
      category: "DICOM Viewer Tool",
      action: "control opacity slider",
    });

    brushModule.setters.useColorSetAlpha((value / 100.0) * 255.0);
    let totalEnabledElement = getEnabledElements();
    let mainEnabledElement = totalEnabledElement[0];
    let toolState = getToolState(
      mainEnabledElement.element,
      BaseBrushTool.getReferencedToolDataName()
    );
    const toolData = toolState.data;
    toolData[0].invalidated = true;
    CustomEvent.triggerEvent(
      mainEnabledElement.element,
      CustomEvent.EVENTS.IMAGE_RENDERED,
      mainEnabledElement
    );

    this.setState({
      opacity: value,
    });
  };

  handleVisibilitySwitch = (value) => {
    // Send user event to Google Analytics
    if (value === true) {
      ReactGA.event({
        category: "DICOM Viewer Tool",
        action: "On opacity",
      });
    } else {
      ReactGA.event({
        category: "DICOM Viewer Tool",
        action: "off opacity",
      });
    }

    this.setState({
      visibility: value,
    });

    brushModule.setters.isActive(value);

    let totalEnabledElement = getEnabledElements();
    let mainEnabledElement = totalEnabledElement[0];
    let toolState = getToolState(
      mainEnabledElement.element,
      BaseBrushTool.getReferencedToolDataName()
    );
    const toolData = toolState.data;
    toolData[0].invalidated = true;
    CustomEvent.triggerEvent(
      mainEnabledElement.element,
      CustomEvent.EVENTS.IMAGE_RENDERED,
      mainEnabledElement
    );
  };

  getVisible() {
    const { disabled } = this.props;
    const { visibility } = this.state;

    if (disabled === true) {
      return false;
    }
    return visibility;
  }

  getDisplayedOpacity() {
    const { disabled } = this.props;
    const { opacity } = this.state;
    if (disabled === true) {
      return 0;
    }
    return opacity;
  }

  render() {
    const { disabled, opacity } = this.props;
    const visible = this.getVisible();
    const displayedOpacity = this.getDisplayedOpacity();
    this.props.sarcopeniaMeasureStore.opacity = displayedOpacity;
    // console.log("opacity: ", opacity);

    return (
      <div className="control-item">
        <label className="item-title">
          {"Opacity"}
          <span className="item-title-sub pull-right">
            <ReactSwitch
              disabled={disabled}
              checked={visible}
              onChange={this.handleVisibilitySwitch}
            />
            <label
              className="item-title-sub__text item-title--bolder"
              style={{ width: "50px", textAlign: "right" }}
            >
              {`${displayedOpacity}%`}
            </label>
          </span>
        </label>

        <div className="item-content">
          <div className="opacity-slider">
            <Slider
              min={0}
              max={100}
              disabled={disabled}
              defaultValue={opacity}
              onChange={this.handleOpacitySliderChange}
              step={1}
              marks={{ 0: { label: "0" }, 100: { label: "100" } }}
              handle={handle}
              handleStyle={{
                bottom: "15px",
                visibility: "hidden",
              }}
              trackStyle={{
                backgroundImage:
                  "-webkit-linear-gradient(left, #2c3493, #06a3cd, #2c3493)",
                height: "5px",
              }}
              railStyle={{ backgroundColor: "#030919", height: "5px" }}
              dotStyle={{ display: "none" }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default OpacityPanel;
